import { NotFoundView } from 'app/views/layout/views/notFound';
import { FormValues } from 'components/settings/components/sections/dixaMessenger/views/settings/types';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { LoadingScreen, MessengerSettingsPage } from './components';
import { useMessengerSettings } from './hooks';
import { extractInitialValuesFromMessenger } from './hooks/utils';
import { presetBackgrounds } from './presetBackgrounds';

export const MessengerSettingsView = (): JSX.Element => {
  const { messengerId } = useAppPathParams(
    '/settings/dixa-messenger/settings/:messengerId',
  );

  const {
    isLoading,
    setSettings,
    messenger,
    bulletinBoardId,
    fallbackSettings,
  } = useMessengerSettings(messengerId);

  const initialValues: Partial<FormValues> = extractInitialValuesFromMessenger(
    messenger,
    fallbackSettings,
  );

  const avatars: string[] =
    messenger?.settings?.avatars?.map((avatar) =>
      avatar.type === 'fixed' ? avatar.fixed.url : avatar.random.url,
    ) ?? [];

  if (!messenger) {
    if (!isLoading) {
      return (
        <NotFoundView
          navigatePath="/settings/dixa-messenger"
          name="Messenger"
        />
      );
    }

    return <LoadingScreen />;
  }

  if (!bulletinBoardId) {
    // bulletinBoardId is automatically created if it's missing.
    return <LoadingScreen />;
  }

  return (
    <MessengerSettingsPage
      messengerId={messenger.id}
      messengerToken={messenger.token}
      onSubmit={setSettings}
      initialValues={initialValues}
      messengerName={messenger.name}
      presetBackgrounds={presetBackgrounds}
      isLoading={isLoading}
      bulletinBoardId={bulletinBoardId}
      avatars={avatars}
    />
  );
};
